import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ImgIcon, BrandButton } from "../assets";
import { location } from "../assets/icons";
import { getPlaces, getPlaceDetails } from "../helpers";

const blankAddress = {
	line1: "",
	line2: "",
	town: "",
	postCode: "",
}

export default function AddressLookup({ onChange, origin }) {

	const {
		session: { token }
	} = useSelector(state => ({
		session: state.session
	}));

	const [query, setQuery] = useState("");
	const [error, setError] = useState("");
	const [places, setPlaces] = useState([]);
	const [selected, setSelected] = useState(null);
	const [address, setAddress] = useState(blankAddress);
	const [open, setOpen] = useState(false);
	
	useEffect(() => {
		const to = setTimeout(() => {
			setError("");
			getPlaces(query, token, origin)
				.then(setPlaces)
				.catch(setError);
		}, 500);
		return () => {
			clearTimeout(to);
		}
	}, [query, token, origin]);

	useEffect(() => {
		if (selected) {
			setError("");
			getPlaceDetails(selected.id, token)
				.then(setAddress)
				.catch(setError);
		}
	}, [selected, token]);

	return <div className="addressLookup">
		<input
			type="text"
			autoComplete="off"
			value={query}
			onChange={e => setQuery(e.target.value)}
			placeholder={"Search for your address.."}
			onFocus={e => setOpen(true)}
			onBlur={e => {
				setTimeout(e => {
					setOpen(false);
					setSelected(null);
				}, 500);
			}}
		/>
		{open && Boolean(places.length) && <span
			className="close"
			onClick={e => setOpen(false)}
		>x</span>}
		{Boolean(places.length) && !selected && open && <div className="places">
			{places.map(place => {

				let distance;
				if (place.distance) {
					distance = (place.distance * 0.000621371).toFixed(1);
					if (distance < 0.1) distance = 0.1;
				}

				return <div
					className="place"
					key={place.id}
					onClick={e => {
						setQuery("");
						setSelected(place);
					}}
				>
					<ImgIcon
						src={location}
						size={20}
					/>
					{place.name}
					{/* - ({place.type}) */}
					{distance && <span className="distance">{distance}m</span>}
				</div>
			})}
			<span className="powered-by-google">Powered by Google's <a rel="noopener noreferrer" target="_blank" href="https://cloud.google.com/maps-platform/places">Places API</a>.</span>
		</div>}
		{error && <div className="error">
			{error}
		</div>}
		<br />
		<div>Or enter manually:</div>
		<br />
		<form className="address-fields" onSubmit={e => e.preventDefault()} autoComplete="on">
			<input
				type="text"
				value={address.line1}
				placeholder="Line 1"
				onChange={e => setAddress({ ...address, line1: e.target.value, mapLink: null, location: null })}
			/>
			<input
				type="text"
				value={address.line2}
				placeholder="Line 2"
				onChange={e => setAddress({ ...address, line2: e.target.value, mapLink: null, location: null })}
			/>
			<input
				type="text"
				value={address.town}
				placeholder="Town"
				onChange={e => setAddress({ ...address, town: e.target.value, mapLink: null, location: null })}
			/>
			<input
				type="text"
				value={address.postCode}
				placeholder="Postcode"
				onChange={e => setAddress({ ...address, postCode: e.target.value, mapLink: null, location: null })}
			/>
		</form>
		{(
			address.line1 &&
			address.town &&
			address.postCode
		) && <BrandButton
			onClick={e => {
				if (onChange) onChange(address);
			}}
		>Confirm address</BrandButton>}
	</div>
}

